import gql from 'graphql-tag';

export default gql`
  query channels(
    $channelLimit: Int
    $channelOffset: Int
  ) {
    channels(
      limit: $channelLimit
      offset: $channelOffset
    ) {
      id
      uri
      address
      imageUrl
      websiteUrl
      twitterUrl
      description
      displayName
      facebookUrl
      instagramUrl
      contentCount
      numberOfFollowers

      tags {
        title
      }

      organization {
        accountName
      }
    }
  }
`;
